import axios from "axios";

const baseUrl = process.env.REACT_APP_API_URL.replace(/\/+$/, "");
const API_BASE_URL = `${baseUrl}/`;

export const getSearchResults = async (searchTerm) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}search/?query=${searchTerm}`,
      {
        headers: {
          "Access-Control-Allow-Origin": "*",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching search results:", error);
    throw error;
  }
};

export const getWorkflows = async (pageNumber) => {
  try {
    const params = pageNumber ? `?page=${pageNumber}` : "";
    const response = await axios.get(`${API_BASE_URL}files/${params}`, {
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching files:", error);
    throw error;
  }
};

export const getWorkflowsSearch = async (searchTerm, pageNumber, sort) => {
  try {
    let params = pageNumber ? `?page=${pageNumber}` : "";
    params += searchTerm ? `&any=${searchTerm}` : "";
    params += sort ? `&sort=${sort}` : "";
    const response = await axios.get(`${API_BASE_URL}files/search${params}`, {
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching files:", error);
    throw error;
  }
};

export const getWorkflowsByUserId = async (userId, pageNumber, sort) => {
  try {
    let params = pageNumber ? `?page=${pageNumber}` : "";
    params += sort ? `&sort=${sort}` : "";
    params += userId ? `&user=${userId}` : "";
    const response = await axios.get(`${API_BASE_URL}files/search?${params}`, {
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching files:", error);
    throw error;
  }
};

export const getWorkflowInfoById = async (id) => {
  try {
    const response = await axios.get(`${API_BASE_URL}files/${id}`, {
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching workflow:", error);
    throw error;
  }
};

export const getWorkflowByFileName = async (fileName, count = false) => {
  const response = await axios.get(
    `${API_BASE_URL}files/download/${fileName}?count=${count}`,
    {
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
    }
  );
  return response.data;
};

export const getWorkflowById = async (id, count = false) => {
  const workflowInfo = await axios.get(`${API_BASE_URL}files/${id}`, {
    headers: {
      "Access-Control-Allow-Origin": "*",
    },
  });
  const response = await axios.get(
    `${API_BASE_URL}files/download/${workflowInfo.data.file}?count=${count}`,
    {
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
    }
  );
  return response.data;
};

export const deleteWorkflow = async (id, token) => {
  try {
    const response = await axios.delete(`${API_BASE_URL}files/${id}`, {
      headers: {
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${token}`,
      },
    });
    return response.status === 200;
  } catch (error) {
    console.error("Error deleting workflow:", error);
    return false;
  }
};

export const updateWorkflow = async (id, workflow, token) => {
  try {
    // Convert the comma-separated string to an array before sending
    if (workflow.tags && typeof workflow.tags === "string") {
      workflow.tags = workflow.tags
        .split(",")
        .map((tag) => tag.trim())
        .filter((tag) => tag);
    }

    const response = await axios.put(`${API_BASE_URL}files/${id}`, workflow, {
      headers: {
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${token}`,
      },
    });
    return response.status === 200;
  } catch (error) {
    console.error("Error updating workflow:", error);
    return false;
  }
};

export const downloadExampleFile = async (id) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}files/${id}/example/download`,
      {
        headers: {
          "Access-Control-Allow-Origin": "*",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error downloading file:", error);
    throw error;
  }
};

export const getWorkflowIsLiked = async (id, token) => {
  try {
    const response = await axios.get(`${API_BASE_URL}files/${id}/like`, {
      headers: {
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data.has_liked;
  } catch (error) {
    console.error("Error fetching workflow user like:", error);
    throw error;
  }
};

export const likeWorkflow = async (id, token) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}files/${id}/like`,
      {},
      {
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.status === 201;
  } catch (error) {
    console.error("Error liking workflow:", error);
    throw error;
  }
};

export const unlikeWorkflow = async (id, token) => {
  try {
    const response = await axios.delete(`${API_BASE_URL}files/${id}/like`, {
      headers: {
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${token}`,
      },
    });
    return response.status === 200;
  } catch (error) {
    console.error("Error unliking workflow:", error);
    throw error;
  }
};

export const getFollowersByUserId = async (userId) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}users/${userId}/followers`,
      {
        headers: {
          "Access-Control-Allow-Origin": "*",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching followers:", error);
    throw error;
  }
};

export const getFollowingByUserId = async (userId) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}users/${userId}/following`,
      {
        headers: {
          "Access-Control-Allow-Origin": "*",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching following:", error);
    throw error;
  }
};

export const getUserFollowing = async (token) => {
  try {
    const response = await axios.get(`${API_BASE_URL}users/following`, {
      headers: {
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching workflow user like:", error);
    throw error;
  }
};

export const followUser = async (id, token) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}users/${id}/follow`,
      {},
      {
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.status === 201;
  } catch (error) {
    console.error("Error following user:", error);
    throw error;
  }
};

export const unfollowUser = async (id, token) => {
  try {
    const response = await axios.delete(`${API_BASE_URL}users/${id}/follow`, {
      headers: {
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${token}`,
      },
    });
    return response.status === 200;
  } catch (error) {
    console.error("Error unfollowing user:", error);
    throw error;
  }
};

export const getUserById = async (id) => {
  try {
    const response = await axios.get(`${API_BASE_URL}users/${id}`, {
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching user:", error);
    throw error;
  }
};

export const getWorkflowDownloads = async (id) => {
  try {
    const response = await axios.get(`${API_BASE_URL}files/${id}/downloads`);
    return response.data;
  } catch (error) {
    console.error("Error fetching workflow downloads:", error);
    throw error;
  }
};

export const getDiscussionById = async (id) => {
  try {
    const response = await axios.get(`${API_BASE_URL}discussions/${id}`, {
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching discussion:", error);
    throw error;
  }
};

export const getDiscussionComments = async (id) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}discussions/${id}/comments`,
      {
        headers: {
          "Access-Control-Allow-Origin": "*",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching discussion comments:", error);
    throw error;
  }
};

export const createDiscussion = async (token, discussion) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}discussions/`,
      discussion,
      {
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (response.status === 201) {
      return response.data;
    } else {
      throw ("Failed to create discussion. Response status:", response.status);
    }
  } catch (error) {
    console.error("Error creating discussion:", error);
    throw error;
  }
};

export const createComment = async (token, comment) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}discussions/comments`,
      comment,
      {
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (response.status === 201) {
      return response.data;
    } else {
      throw ("Failed to create comment. Response status:", response.status);
    }
  } catch (error) {
    console.error("Error creating comment:", error);
    throw error;
  }
};

export const updateComment = async (token, comment) => {
  try {
    const response = await axios.put(
      `${API_BASE_URL}discussions/comments/${comment.id}`,
      comment,
      {
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (response.status === 200) {
      return response.data;
    } else {
      throw ("Failed to update comment. Response status:", response.status);
    }
  } catch (error) {
    console.error("Error updating comment:", error);
    throw error;
  }
};

export const getUsersComments = async (userId) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}users/${userId}/comments`,
      {
        headers: {
          "Access-Control-Allow-Origin": "*",
        },
      }
    );
    if (response.status === 200) {
      return response.data;
    } else {
      throw ("Failed to get user comments. Response status:", response.status);
    }
  } catch (error) {
    console.error("Error fetching user comments:", error);
    throw error;
  }
};

export const getTokens = async (token) => {
  try {
    const response = await axios.get(`${API_BASE_URL}tokens/`, {
      headers: {
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching files:", error);
    throw error;
  }
};

export const createToken = async (token) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}tokens/`,
      {},
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (response.status === 201) {
      const data = response.data;
      return data.token;
    } else {
      throw ("Failed to generate token. Response status:", response.status);
    }
  } catch (error) {
    console.error("Error generating token:", error);
  }
};

export const deleteToken = async (token, tokenId) => {
  try {
    const response = await axios.delete(`${API_BASE_URL}tokens/${tokenId}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.status === 200) {
      return true;
    } else {
      throw ("Failed to delete token. Response status:", response.status);
    }
  } catch (error) {
    console.error("Error deleting token:", error);
  }
};

export const getCurrentUserInfo = async (token) => {
  try {
    const response = await axios.get(`${API_BASE_URL}users/me`, {
      headers: {
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching current user info:", error);
    throw error;
  }
};

export const updatePassword = async (token, newPassword) => {
  try {
    const response = await axios.put(
      `${API_BASE_URL}users/me/password`,
      {
        password: newPassword,
      },
      {
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.status === 200;
  } catch (error) {
    console.error("Error updating password:", error);
    throw error;
  }
};

export const updateUserInfo = async (token, userInfo) => {
  try {
    const response = await axios.put(`${API_BASE_URL}users/me`, userInfo, {
      headers: {
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${token}`,
      },
    });
    return response.status === 200;
  } catch (error) {
    console.error("Error updating user info:", error);
    throw error;
  }
};

export const uploadAvatar = async (token, formData) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}users/me/avatar`,
      formData,
      {
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.status === 200 || response.status === 201;
  } catch (error) {
    console.error("Error uploading avatar:", error);
    return false;
  }
};

export const deleteAccount = async (token) => {
  try {
    const response = await axios.delete(`${API_BASE_URL}users/me`, {
      headers: {
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${token}`,
      },
    });
    return response.status === 200;
  } catch (error) {
    console.error("Error deleting account:", error);
    throw error;
  }
};

export const getDiscussionsForWorkflow = async (id) => {
  try {
    const response = await axios.get(`${API_BASE_URL}discussions/file/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching workflow discussions:", error);
    throw error;
  }
};

export const updateDiscussionStatus = async (token, discussionId, closed) => {
  try {
    const response = await axios.put(
      `${API_BASE_URL}discussions/${discussionId}`,
      { closed },
      {
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(
        `Failed to update discussion status. Response status: ${response.status}`
      );
    }
  } catch (error) {
    console.error("Error updating discussion status:", error);
    throw error;
  }
};

export const uploadWorkflowExample = async (workflowId, formData, token) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}files/${workflowId}/example`,
      formData,
      {
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error uploading workflow example:", error);
    if (error.response && error.response.data) {
      throw new Error(
        error.response.data.message || "Failed to upload example"
      );
    }
    throw error;
  }
};

export const replaceWorkflow = async (id, formData, token) => {
  try {
    const response = await axios.put(`${API_BASE_URL}files/${id}`, formData, {
      headers: {
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error replacing workflow:", error);
    if (error.response && error.response.data) {
      throw new Error(
        error.response.data.error || "Failed to replace workflow"
      );
    }
    throw error;
  }
};

export const logWorkflowRun = async (workflowId, taskId, token) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}runs/`,
      { workflow_id: workflowId, task_id: taskId },
      {
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error logging workflow run:", error);
    throw error;
  }
};

export const updateWorkflowRunStatus = async (taskId, status, token) => {
  try {
    const response = await axios.put(
      `${API_BASE_URL}runs/${taskId}`,
      { status },
      {
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error updating workflow run status:", error);
    throw error;
  }
};

// export const getWorkflowById = async (id) => {
//   try {
//     const response = await axios.get(`${API_BASE_URL}/workflows/${id}`);
//     return response.data;
//   } catch (error) {
//     console.error('Error fetching workflow:', error);
//     throw error;
//   }
// };

export const launchStudio = async (token) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}studio/launch`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error launching studio:", error);
    throw error;
  }
};

export const terminateStudio = async (token) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}studio/terminate`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error terminating studio:", error);
    throw error;
  }
};
